import ResponsivePopper from './ResponsivePopper'

export type { ResponsivePopperProps } from './ResponsivePopper'
export default ResponsivePopper
